<template>
    <div v-if="simulation">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-6 order-lg-2">
                    <simulation ref="simulation"
                        :registration="registration"
                        :simulation="simulation"
                        :competencies="competencies">
                    </simulation>
                    <sessions
                        :registration="registration"
                        :simulation="simulation"
                        :simulations="simulations"
                        :sessions="sessions"
                        :learners="learners"
                        :group="group"
                        @sharedFeedbacks="$refs.simulation.setSharedFeedbacks($event)"
                    >
                    </sessions>
                </div>
                <div class="col-lg-6 order-lg-1">
                    <learners
                        :registration="registration"
                        :simulation="simulation"
                        :learners="learners"
                        :group="group"
                    ></learners>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Learners from './cohort/SimulationLearners'
    import Simulation from './cohort/Simulation';
    import Groups from './cohort/GroupsCrud';
    import Sessions from './cohort/SessionsCrud';

    export default {

        components: {
            Learners, Simulation, Groups, Sessions
        },

        data() {
            return {
                simulation: null,
                simulations: null,
                sessions: null,
                group: null,
                registration: null,
                learners: null,
                competencies: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/groups/'+to.params.groupId)
            .then(resp => {
                next(vm => {
                    vm.simulation = resp.data.data
                    vm.simulations = resp.data.included.simulations
                    vm.sessions = resp.data.included.sessions
                    vm.group = resp.data.included.group
                    vm.registration = resp.data.included.registration
                    vm.learners = resp.data.included.learners
                    vm.competencies = resp.data.included.competencies
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
